<template>
  <b-container>
    <b-button size="sm" @click="modalOpen">Adicionar formulário</b-button>
    <!-- {{options}} -->
    <b-modal
      ref="openModal"
      class="filterDateModal"
      scrollable
      title="Selecione o formulário"
      @ok="modalOk"
    >
      <label>Formulário: </label>
      <b-form-select v-model="form" :options="optionsForm"> </b-form-select>
      <!-- {{ formId }} -->
      <!-- {{ form }} -->
      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <b-button variant="green" @click="ok()">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "ModuleMenuFormModal",
  components: {
    BaseInputInteger: () =>
      import("@/components_rms/base/BaseInputInteger.vue"),
  },
  props: {
    newField: Array,
    moduleId: String,
    name: String,
    options: Array,
  },
  data: function () {
    return {
      optionsForm: [],
      form: 0,
      formName: "",
      field: [
        {
          formId: 0,
          powerBiViewId: 0,
          sequenceNumber: 0,
          moduleId: this.id,
        },
      ],
    };
  },
  created() {
    this.getAllForms();
  },
  methods: {
    modalOpen() {
      this.$refs.openModal.show();
    },
    getAllForms() {
      this.$apiScheduler
        .get("/module/getAllForms/")
        .then((response) => {
          this.optionsForm = response.data;
        })
        .catch((error) => {
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    getFormName() {
      if (this.form != 0) {
        this.$apiScheduler
          .get("/module/getFormName/" + this.form)
          .then((response) => {
            this.formName = response.data.nome;
          })
          .catch((error) => {
            this.alert.error =
              error.response.status + " - " + error.response.statusText;
            this.$refs.danger.show();
          });
      }
    },
    newModel() {
      this.field.formId = this.form;
      this.field.powerBiViewId = null;
      this.field.sequenceNumber = 0;
      this.field.moduleId = this.moduleId;
      this.field.formName = this.formName;
      this.field.biName = null;
      this.$emit("update:newField", this.field);
      this.$forceUpdate();
    },
    modalOk() {
      this.newModel();
      this.form = 0;
      this.formName = "";
      this.field = [];
    },
    removeFromDropdown() {
      let remove = [];
      this.options.forEach((item) => {
        this.optionsForm.forEach((form) => {
          if (form.value == item.value) {
            remove.push(form);
          }
        });
      });
      remove.forEach((d) => {
        let itemIndex = this.optionsForm.indexOf(d);
          if (itemIndex >= 0) {
          this.optionsForm.splice(itemIndex, 1);
        }
      });
      
    },
  },
  watch: {
    form() {
      this.getFormName();
    },
    options(){
      this.removeFromDropdown();
    }

  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>
